<div class="report-config print-hide">
    <div class="config-groups-row">
        <div class="config-group">
            <div class="config-group__header">{{ "REPORT.DataSetup" | translate }}</div>
            <div class="row">
                <div class="controls controls--dates">
                    <div class="section-label">{{ "REPORT.Dates" | translate }}</div>
                    <mat-form-field class="date-field">
                        <input
                            matInput
                            [matDatepicker]="start"
                            placeholder="{{ 'DEVICE.StartDate' | translate }}"
                            [(ngModel)]="startDate"
                        />
                        <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
                        <mat-datepicker #start></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field class="date-field date-field--time">
                        <input
                            matInput
                            [(ngModel)]="startTime"
                            [matTimepicker]="startTimePicker"
                            placeholder="{{ 'DEVICE.StartTime' | translate }}"
                        />
                        <mat-timepicker-toggle matSuffix [for]="startTimePicker"></mat-timepicker-toggle>
                        <mat-timepicker #startTimePicker interval="30m"></mat-timepicker>
                    </mat-form-field>
                    <mat-form-field class="date-field">
                        <input matInput [matDatepicker]="end" placeholder="{{ 'DEVICE.EndDate' | translate }}" [(ngModel)]="endDate" />
                        <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
                        <mat-datepicker #end></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field class="date-field date-field--time">
                        <input
                            matInput
                            [(ngModel)]="endTime"
                            [matTimepicker]="endTimePicker"
                            placeholder="{{ 'DEVICE.EndTime' | translate }}"
                        />
                        <mat-timepicker-toggle matSuffix [for]="endTimePicker"></mat-timepicker-toggle>
                        <mat-timepicker #endTimePicker interval="30m"></mat-timepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="controls">
                    <div class="section-label">{{ "REPORT.Fields" | translate }}</div>
                    <div class="field-selection-panel">
                        <table class="field-selection-table">
                            <thead>
                                <tr>
                                    <th>{{ "REPORT.Interval" | translate }}</th>
                                    <th>{{ "REPORT.AWeighting" | translate }}</th>
                                    <th>{{ "REPORT.CWeighting" | translate }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (row of reportSeriesFieldRows; track row.id) {
                                    <tr>
                                        <td class="field-selection-label">
                                            {{ row.labelKey | translate }}
                                        </td>
                                        <td class="field-selection-cell">
                                            @if (row.aField; as aField) {
                                                <div class="field-selection-editor">
                                                    <label class="field-selection-checkbox" [attr.aria-label]="aField.labelKey | translate">
                                                        <input type="checkbox" [(ngModel)]="aField.enabled" />
                                                    </label>
                                                    <div
                                                        class="field-selection-preview"
                                                        tabindex="0"
                                                        [attr.aria-label]="aField.labelKey | translate"
                                                    >
                                                        <span
                                                            class="field-selection-preview__line"
                                                            [class.field-selection-preview__line--dashed]="aField.lineStyle === 'ShortDash'"
                                                            [class.field-selection-preview__line--dotted]="aField.lineStyle === 'Dot'"
                                                            [style.color]="aField.color"
                                                            [style.background-color]="
                                                                aField.lineStyle === 'Solid' ? aField.color : 'transparent'
                                                            "
                                                            [style.border-color]="aField.color"
                                                        ></span>
                                                        <div class="field-selection-popover">
                                                            <input
                                                                class="field-selection-color-input"
                                                                type="color"
                                                                [(ngModel)]="aField.color"
                                                                [attr.aria-label]="
                                                                    ('REPORT.Color' | translate) + ' ' + ('REPORT.AWeighting' | translate)
                                                                "
                                                            />
                                                            <select
                                                                class="field-selection-style-select"
                                                                [(ngModel)]="aField.lineStyle"
                                                                [attr.aria-label]="
                                                                    ('REPORT.LineStyle' | translate) +
                                                                    ' ' +
                                                                    ('REPORT.AWeighting' | translate)
                                                                "
                                                            >
                                                                @for (option of reportLineStyleOptions; track option.value) {
                                                                    <option [ngValue]="option.value">
                                                                        {{ option.labelKey | translate }}
                                                                    </option>
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            } @else {
                                                <span class="field-selection-empty">-</span>
                                            }
                                        </td>
                                        <td class="field-selection-cell">
                                            @if (row.cField; as cField) {
                                                <div class="field-selection-editor">
                                                    <label class="field-selection-checkbox" [attr.aria-label]="cField.labelKey | translate">
                                                        <input type="checkbox" [(ngModel)]="cField.enabled" />
                                                    </label>
                                                    <div
                                                        class="field-selection-preview"
                                                        tabindex="0"
                                                        [attr.aria-label]="cField.labelKey | translate"
                                                    >
                                                        <span
                                                            class="field-selection-preview__line"
                                                            [class.field-selection-preview__line--dashed]="cField.lineStyle === 'ShortDash'"
                                                            [class.field-selection-preview__line--dotted]="cField.lineStyle === 'Dot'"
                                                            [style.color]="cField.color"
                                                            [style.background-color]="
                                                                cField.lineStyle === 'Solid' ? cField.color : 'transparent'
                                                            "
                                                            [style.border-color]="cField.color"
                                                        ></span>
                                                        <div class="field-selection-popover">
                                                            <input
                                                                class="field-selection-color-input"
                                                                type="color"
                                                                [(ngModel)]="cField.color"
                                                                [attr.aria-label]="
                                                                    ('REPORT.Color' | translate) + ' ' + ('REPORT.CWeighting' | translate)
                                                                "
                                                            />
                                                            <select
                                                                class="field-selection-style-select"
                                                                [(ngModel)]="cField.lineStyle"
                                                                [attr.aria-label]="
                                                                    ('REPORT.LineStyle' | translate) +
                                                                    ' ' +
                                                                    ('REPORT.CWeighting' | translate)
                                                                "
                                                            >
                                                                @for (option of reportLineStyleOptions; track option.value) {
                                                                    <option [ngValue]="option.value">
                                                                        {{ option.labelKey | translate }}
                                                                    </option>
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            } @else {
                                                <span class="field-selection-empty">-</span>
                                            }
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="row alarms-row">
                <div class="controls">
                    <div class="section-label">{{ "TAB.Alarms" | translate }}</div>
                    <div class="display-options display-options--alarms">
                        @for (alarm of alarms; track alarm) {
                            <mat-slide-toggle [(ngModel)]="alarm.selected"
                                >{{ alarm.name }} ({{ describeAlarmLimits(alarm) }} dB)</mat-slide-toggle
                            >
                        }
                    </div>
                </div>
            </div>
        </div>
        <div class="config-group config-group--secondary">
            <div class="config-group__header">{{ "REPORT.ReportOptions" | translate }}</div>
            <div class="row">
                <div class="controls">
                    <div class="section-label">{{ "REPORT.YAxisRange" | translate }}</div>
                    <mat-form-field style="margin-right: 32px">
                        <input matInput type="number" [(ngModel)]="yAxisMin" placeholder="{{ 'REPORT.YAxisMin' | translate }}" step="1" />
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput type="number" [(ngModel)]="yAxisMax" placeholder="{{ 'REPORT.YAxisMax' | translate }}" step="1" />
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="controls">
                    <div class="section-label">{{ "REPORT.Options" | translate }}</div>
                    <div class="display-options">
                        <mat-slide-toggle [(ngModel)]="showComments">{{ "REPORT.DeviceComments" | translate }}</mat-slide-toggle>
                        <mat-slide-toggle [(ngModel)]="showPeriodBands">{{ "REPORT.PeriodBands" | translate }}</mat-slide-toggle>
                    </div>
                </div>
            </div>
            <div class="row custom-limit-row">
                <div class="controls">
                    <div class="section-label">{{ "REPORT.CustomAlarm" | translate }}</div>
                    <mat-form-field>
                        <input
                            matInput
                            type="number"
                            [(ngModel)]="customAlarm"
                            placeholder="{{ 'REPORT.CustomAlarm' | translate }}"
                            step="1"
                        />
                    </mat-form-field>
                </div>
            </div>
            <div class="observation-row row">
                <div class="controls">
                    <div class="section-label">{{ "REPORT.Observations" | translate }}</div>
                    <mat-form-field class="observation-field">
                        <textarea matInput [(ngModel)]="observation" placeholder="{{ 'REPORT.Observations' | translate }}"></textarea>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    <div class="row action-row">
        <div class="controls">
            <button mat-raised-button color="primary" (click)="generateReport()">
                {{ "REPORT.GenerateReport" | translate }}
            </button>
        </div>
    </div>
</div>
@if (loadingData) {
    <div class="loading">
        <mat-spinner diameter="32" color="primary" style="margin: auto"></mat-spinner>
    </div>
}
@if (generated) {
    <div class="report" #reportContainer>
        <img class="logo" src="assets/images/logos/emma.svg" />
        <table #reportTable>
            <tr>
                <td colspan="2" class="header">
                    {{ "REPORT.General" | translate }}
                </td>
            </tr>
            <tr>
                <td class="field">{{ "REPORT.ProjectName" | translate }}</td>
                <td class="value">{{ project?.name || "-" }}</td>
            </tr>
            <tr>
                <td class="field">{{ "REPORT.Device" | translate }}</td>
                <td class="value">
                    {{ brand }} {{ device.baseDeviceData?.model }} /
                    {{ device.baseDeviceData?.serialNumber }}
                </td>
            </tr>
            <tr>
                <td class="field">{{ "REPORT.Dates" | translate }}</td>
                <td class="value">
                    {{ reportDateRangeLabel }}
                </td>
            </tr>
            <tr>
                <td class="field">{{ "REPORT.GPS" | translate }}</td>
                <td class="value">{{ device.location.latitude }} - {{ device.location.longitude }}</td>
            </tr>
            <tr>
                <td class="field">{{ "REPORT.Address" | translate }}</td>
                <td class="value">{{ device.location.address }}</td>
            </tr>
            @if (showComments) {
                <tr>
                    <td class="field">{{ "REPORT.DeviceComments" | translate }}</td>
                    <td class="value">{{ device.comments }}</td>
                </tr>
            }
            @if (observation) {
                <tr>
                    <td colspan="2" class="header">
                        {{ "REPORT.Observations" | translate }}
                    </td>
                </tr>
            }
            @if (observation) {
                <tr>
                    <td colspan="2" class="value breaks">
                        {{ observation }}
                    </td>
                </tr>
            }
            <tr>
                <td class="header">
                    {{ "REPORT.Map" | translate }}
                </td>
                <td class="header">
                    {{ "REPORT.Photo" | translate }}
                </td>
            </tr>
            <tr>
                <td class="map">
                    @if (validCoordinates) {
                        <div
                            class="report-map"
                            leaflet
                            [leafletOptions]="reportMapOptions"
                            [leafletLayers]="reportMapLayers"
                            [leafletCenter]="reportMapCenter"
                            [leafletZoom]="zoom"
                        ></div>
                    } @else {
                        <div class="map-fallback">
                            {{ "DEVICE.NoGPSData" | translate }}
                        </div>
                    }
                </td>
                <td class="image">
                    @if (pictureCloudinaryImage; as reportImage) {
                        <advanced-image [cldImg]="reportImage"></advanced-image>
                    } @else {
                        <img [src]="picture" alt="device picture" />
                    }
                </td>
            </tr>
            <tr>
                <td colspan="2" class="header">
                    {{ "REPORT.Graph" | translate }}
                </td>
            </tr>
        </table>
        @if (reportLegendItems.length > 0) {
            <div class="report-legend" #reportLegend>
                @for (item of reportLegendItems; track item.labelKey || item.label) {
                    <div class="report-legend__item">
                        <span
                            class="report-legend__line"
                            [class.report-legend__line--dashed]="item.lineStyle === 'ShortDash'"
                            [class.report-legend__line--dotted]="item.lineStyle === 'Dot'"
                            [style.color]="item.color"
                            [style.background-color]="item.lineStyle === 'Solid' ? item.color : 'transparent'"
                            [style.border-color]="item.color"
                        ></span>
                        <span class="report-legend__label">
                            {{ item.labelKey ? (item.labelKey | translate) : item.label }}
                        </span>
                    </div>
                }
            </div>
        }
        @if (deviceData) {
            <highcharts-chart
                [Highcharts]="Highcharts"
                [constructorType]="chart.constructor"
                [options]="chart.options"
                [(update)]="chart.update"
                [callbackFunction]="chartCallback"
                [style.width.%]="100"
                [style.height.px]="reportChartHeight"
                style="display: block"
            ></highcharts-chart>
        }
    </div>
}
